import { useMutation } from '@tanstack/react-query';

import { BASE_URL_LANG } from '@/api/utils.ts';
import axios, { AxiosError, AxiosResponse } from 'axios';
import {
  LostPasswordPostError,
  LostPasswordPostParams,
  LostPasswordPostResponse,
} from '@/api/model/authentication/lostpassword.ts';

const useLostPasswordPost = () =>
  useMutation<
    AxiosResponse<LostPasswordPostResponse>,
    AxiosError<LostPasswordPostError>,
    LostPasswordPostParams
  >({
    mutationFn: ({ email, sendPassword, sec_token, type }) => {
      const body = new FormData();
      body.append('sendPassword', sendPassword);
      body.append('email', email);
      body.append('type', type);
      body.append('sec_token', sec_token);

      return axios.post(`${BASE_URL_LANG}lostpassword/${type}`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
          // Backend requires this header
          internal: 1,
        },
      });
    },
  });

export { useLostPasswordPost };
